module.exports = __webpack_public_path__ + "i18n/ko_82daca72c188ba681afac42402da610b.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 151